// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Gj2z","consentsList":"PatientConsents_consentsList__1lIVb","consentsListEmpty":"PatientConsents_consentsListEmpty__2Tx3Q"};